class Variacio {
    constructor(
        public id= 0,
        public nom= "",
        public comentaris= "",
        public estat= 0,
    ){
        this.id = id;
        this.nom = nom;
        this.comentaris = comentaris;
        this.estat = estat;
    }
}
export default Variacio;